export default {
      id: "ic_coupon_detail-usage",
      viewBox: "0 0 16 16",
      url: "/" + "images/icons.3.109.2.svg#ic_coupon_detail-usage",
      toString: function () {
        return this.url;
      }
    }